/**
 * @fileoverview Shared internationalization key mappings for reusable domain concepts.
 * @module shared/i18n/keyMaps
 */

import type { AggregationType } from '@/shared/context/FilterContext'

/**
 * Translation key map for aggregation options shared across header controls.
 */
export const AGGREGATION_TRANSLATION_KEYS: Record<AggregationType, string> = {
  Daily: 'aggregation.daily',
  Weekly: 'aggregation.weekly',
  Monthly: 'aggregation.monthly',
  Quarterly: 'aggregation.quarterly',
  Yearly: 'aggregation.yearly',
} as const

/**
 * Canonical list of aggregation options used across shared controls.
 */
export const AGGREGATION_OPTIONS: readonly AggregationType[] = [
  'Daily',
  'Weekly',
  'Monthly',
  'Quarterly',
  'Yearly',
] as const
